var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-card',{staticClass:"vs-con-loading__container",attrs:{"id":"vendor-table-loading"}},[_c('vs-row',[_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"12"}},[_c('VendorTable',{attrs:{"data":_vm.data},on:{"search":_vm.search,"loadMore":_vm.loadMore,"showDetails":_vm.showDetails}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }